import { DayPicker, DayPickerProps } from 'react-day-picker';
import { cn } from '../../utils';

export type CalendarProps = DayPickerProps;
export const Calendar = ({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) => {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        months: 'flex flex-row',
        month: 'space-y-4',
        selected:
          'text-center [&>button]:l-btn [&>button]:l-icon-btn [&>button]:l-btn-sm [&>button]:l-btn-primary table-cell [&>button]:h-8 [&>button]:w-8 [&>button]:hover:bg-theme-colors-primary-600 ', // Highlight the selected day
        disabled: 'text-neutral-500 cursor-not-allowed',
        caption_label: 'text-title-md capitalize',
        nav: 'space-x-1 flex items-center absolute right-4 ',
        button_next: 'l-btn l-icon-btn l-btn-sm l-btn-tertiary',
        button_previous: 'l-btn l-icon-btn l-btn-sm l-btn-tertiary',

        nav_button: 'l-btn l-btn-sm l-btn-tertiary',
        week: ' flex gap-2',
        weeks: 'flex flex-col gap-2',
        weekdays: 'flex flex-row justify-between gap-2  ',
        weekday: 'text-label-lg h-8 w-8 text-center ',
        day_button:
          'text-neutral-900 text-center l-btn l-icon-btn l-btn-sm l-btn-tertiary table-cell h-8 w-8',
        day_hidden: 'invisible',
        ...classNames,
      }}
      {...props}
    />
  );
};
